var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FilterBase',{attrs:{"label":"Search"}},[_c('GenericSearchInput',{attrs:{"label":"Search Community content","background":"white","full-width":true,"single-line":true,"padding":true,"outlined":true,"white-background":true},on:{"search":_vm.onSearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }